export const toNumber = (
  value: string | number | undefined,
): number | undefined => (value ? Number(value) : undefined)
